import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var CreditCard = function CreditCard(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1313 3.8894H3.85913C1.80249 3.8894 0.726562 4.95581 0.726562 6.99341V7.85034H23.2639V6.99341C23.2639 4.95581 22.1975 3.8894 20.1313 3.8894ZM4.70654 17.3433C4.14478 17.3433 3.76392 16.9719 3.76392 16.4292V14.6677C3.76392 14.1345 4.14478 13.7537 4.70654 13.7537H7.03931C7.59155 13.7537 7.97241 14.1345 7.97241 14.6677V16.4292C7.97241 16.9719 7.59155 17.3433 7.03931 17.3433H4.70654ZM3.85913 20.3901H20.1313C22.1975 20.3901 23.2639 19.3142 23.2639 17.2766V10.0879H0.726562V17.2766C0.726562 19.3237 1.80249 20.3901 3.85913 20.3901Z"
  })));
};

CreditCard.displayName = 'CreditCard';
export default CreditCard;